export const getDiscountedPriceVariant = (variant?: string) => {
  switch (variant) {
    case "pricingOptionCard":
      return "body-sm-bold";
    default:
      return "body-md-bold";
  }
};

export const originalPriceVariant = (variant?: string) => {
  switch (variant) {
    case "topBlock":
      return "body-sm";
    case "horizontalProductCard":
    case "basketCard":
      return "body-md";
    case "pricingOptionCard":
      return "smallprint-md";
    default:
      return "body-md-bold";
  }
};
